export function getFilePathInfo(filePath: string) {
  if (!filePath) {
    return { fileName: "", folderPath: "", fileExtension: "" };
  }

  const parts = filePath.split(/[/\\]/);

  const fileName = parts.pop() ?? "";

  const folderPath = parts.length > 0 ? parts.join("\\") : "";

  const fileExtension = fileName.includes(".") ? fileName.substring(fileName.lastIndexOf(".") + 1) : "";

  return { fileName, folderPath, fileExtension };
}

export function getImageUploadPath(fullPath: string): string {
  const pathList = (fullPath ?? "").split("/").filter(Boolean).reverse();
  const uploadPath = pathList.length >= 2 ? `${pathList[1]}/${pathList[0]}` : pathList[0];
  return uploadPath;
}

/** Splits a relative or absolute folder path into its folder names, whatever the separator. */
export function splitFolderPath(folderPath: string | null | undefined): string[] {
  return (folderPath ?? "")
    .split(/[/\\]/)
    .map((segment) => segment.trim())
    .filter((segment) => segment.length > 0);
}

/** Folders leading to a file, "/" separated; the file name itself is dropped. */
export function folderPathOfFile(filePath: string | null | undefined): string {
  return splitFolderPath(filePath).slice(0, -1).join("/");
}
